export const SET_INSURANCE_COMPANY = 'SET_INSURANCE_COMPANY';

export const setInsuranceCompany = ({ insuranceCompany }) => ({
  type: SET_INSURANCE_COMPANY,
  payload: {
    insuranceCompany
  }
});
